var React = require('react');

function DownloadReport (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.16675 16.6667H15.8334V15H4.16675M15.8334 7.5H12.5001V2.5H7.50008V7.5H4.16675L10.0001 13.3333L15.8334 7.5Z","fill":"white"}));
}

DownloadReport.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = DownloadReport;

DownloadReport.default = DownloadReport;
